import type { HyloServices } from '@/model';
import type { MeDetails } from './types';
export function record(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value);
}
export function readMe(value: unknown): MeDetails {
  if (!record(value) || !record(value.me) || !record(value.me.account) || !record(value.me.settings)
      || typeof value.me.account.id !== 'string' || typeof value.me.account.display_name !== 'string') {
    throw new Error('invalid_response');
  }
  return value.me as unknown as MeDetails;
}
export async function fetchMe(services: HyloServices, signal: AbortSignal) {
  return readMe(await services.http.get<unknown>('/v1/me', { signal }));
}

